export enum ETaskStatus {
  NOT_COMPLETED = 'NOT_COMPLETED',
  COMPLETED = 'COMPLETED',
  NA = 'NA',
}
